<template>
    <div class="min-h-screen">
        <div style="position: relative;">
            <img style="width: 100%;image-rendering: pixelated;" src="../../assets/AI/AI_02.jpg" inferSize
                alt="我们的理念" />
            <div
                style="width:1200px;padding-left: 35px;margin: 0px auto;top: 0px;left: 0px;right: 0px;position: absolute;left: 0px;top: 0px;right: 0px;    height: 100%;display: flex;align-items: center;">
                <div>
                    <div style="font-size: 40px;">DeepSeek落地解决方案</div>
                    <div style="font-size: 16px;margin-top: 30px;color: #666;width: 600px;line-height: 28px;">
                        提供覆盖模型开发全生命周期的完整技术栈，通过整合模型构建平台与应用开发平台，实现从模型训练、部署优化、API服务发布到业务场景落地的端到端闭环，为企业打造“训练-推理-应用”无缝衔接的一站式AI服务体系，大幅降低技术整合复杂度，确保数据安全的同时提升业务迭代效率。
                    </div>
                </div>
            </div>
        </div>
        <div class="relative">
            <img style="height: 600px;margin: 0px auto;" src="../../assets/AI/AI_03.jpg" inferSize alt="我们的理念" />
            <div style="height: 100%;width: 100%;top: 0px;position: absolute;">
                <h2 class="text-center" style="font-size:28px;margin-top: 80px;">企业为什么要接入AI？</h2>
                <div
                    style="margin: 0px auto;margin-top: 55px;height: 60px;width: 480px;text-align: center;line-height: 60px;background: #1e66d1;color: #fff;border-radius: 30px;font-size: 24px;">
                    从“人力驱动”到“智能驱动”的进化
                </div>
                <div style="text-align: center;margin-top: 40px;font-size: 16px;line-height: 2;">
                    <pre>接入AI不再是“锦上添花”，而是关乎企业能否在“数据驱动”的新时代生存与领跑的关键。
AI，正在深刻重构生产要素、重塑生产流程、创造全新价值。它是颠覆传统生产方式、释放数据价值的革命性引擎。</pre>
                </div>
                <div
                    style="display: flex;justify-content: space-around;width: 1200px;margin: 0px auto;margin-top: 55px;">
                    <div
                        style="width: 350px;color: #1e66d1;border: 1px dashed #1e66d1;height: 88px;font-size: 16px;border-radius: 15px;display:flex; justify-content: center;align-items: center;text-align: center;background: #fff;font-weight: bold;">
                        <div>
                            <div>数据成为核心生产资料</div>
                            <div>AI是唯一能“盘活”它的引擎</div>
                        </div>
                    </div>
                    <div
                        style="width: 350px;color: #1e66d1;border: 1px dashed #1e66d1;height: 88px;font-size: 16px;border-radius: 15px;display:flex; justify-content: center;align-items: center;text-align: center;background: #fff;font-weight: bold;">
                        <div>
                            <div>自动化从“体力/流程”升维至</div>
                            <div>“认知/决策”</div>
                        </div>
                    </div>
                    <div
                        style="width: 350px;color: #1e66d1;border: 1px dashed #1e66d1;height: 88px;font-size: 16px;border-radius: 15px;display:flex; justify-content: center;align-items: center;text-align: center;background: #fff;font-weight: bold;">
                        <div>
                            <div>重塑产品、服务与商业模式</div>
                            <div>创造前所未有的价值</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div style="width: 1200px;margin: 0px auto;justify-content:space-around;display: flex;position: relative;border-radius: 10px;
            background-size: 100% 100%;padding: 35px 30px;"
            :style="{ backgroundImage: 'url(' + require('@/assets/AI/AI_01.png') + ')' }">
            <div @click="tof('AI知识库')" style="width: 185px;" class="lifors pointer">
                <div style="margin-top: 20px;"><img src="../../assets/home/ai1@2x.png"
                        style="margin:0px auto;height: 45px;">
                </div>
                <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    AI知识库</div>
                <div style="font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 90px;">
                    企业级智能知识中枢，支持多模态数据融合与语义化推理</div>
                <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                    产品详情>
                </div>
            </div>
            <div @click="tof('AI智能客服')" style="width: 185px;" class="lifors pointer">
                <div style="margin-top: 20px;"><img src="../../assets/home/ai2@2x.png"
                        style="margin:0px auto;height: 45px;">
                </div>
                <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    AI智能客服</div>
                <div style="font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 90px;">
                    基于生成式AI的全渠道对话引擎，实现服务与业务场景智能化</div>
                <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                    产品详情>
                </div>
            </div>
            <div @click="tof('AI智慧党建')" style="width: 185px;" class="lifors pointer">
                <div style="margin-top: 20px;"><img src="../../assets/home/ai3@2x.png"
                        style="margin:0px auto;height: 45px;">
                </div>
                <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    AI智慧党建</div>
                <div style="font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 90px;">
                    AI 智能化党建管理中枢，赋能组织决策与党员服务精准化</div>
                <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                    产品详情>
                </div>
            </div>
            <div @click="tof('AI信息安全')" style="width: 185px;" class="lifors pointer">
                <div style="margin-top: 20px;"><img src="../../assets/home/ai4@2x.png"
                        style="margin:0px auto;height: 45px;">
                </div>
                <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    AI信息安全</div>
                <div style="font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 90px;">
                    轻量化AI安全方案，实时风控与智能响应，大模型重塑防御效率
                </div>
                <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                    产品详情>
                </div>
            </div>
            <div @click="tof('AI舆情监测')" style="width: 185px;" class="lifors pointer">
                <div style="margin-top: 20px;"><img src="../../assets/home/ai5@2x.png"
                        style="margin:0px auto;height: 45px;">
                </div>
                <div style="font-size: 20px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    AI舆情监测</div>
                <div style="font-size: 14px;margin-top: 30px;line-height: 30px;color: #333;height: 90px;">
                    企业微信会话实时分析，挖掘多维声量风险机遇，辅助决策</div>
                <div @click="toe" class="buttondh" style="margin: 30px auto;width: 110px;height: 36px;line-height: 36px;text-align: center;
                    border: 1px solid #1e66d1;border-radius: 30px;font-size: 14px;color: #1e66d1;cursor: pointer;">
                    产品详情>
                </div>
            </div>
        </div>
        <!-- <div
            style="width: 1200px;margin: 0px auto;justify-content: space-between;display: flex;position: relative;margin-top: -20px;">
            <div style="width: 590px;height: 270px;background-size: 100% 100%;text-align: center;cursor: pointer;" @click="zhichiku"
                :style="{ backgroundImage: 'url(' + require('@/assets/AI/AI_01.png') + ')' }">
                <div style="margin-top: 30px;"><img style="margin: 0px auto;width:60px;"
                        src="../../assets/AI/AI_04.png"></div>
                <div style="margin-top: 20px;font-size: 20px;font-weight: bold;">DeepSeek+知识库</div>
                <div style="margin-top: 15px;font-size: 15px;">企业级智能知识中枢，支持多模态数据融合与语义化推理</div>
                <div
                    style="margin: 0px auto; margin-top: 20px;width: 110px;height: 36px;line-height: 36px;color: #1e66d1;border: 1px solid #1e66d1;border-radius: 20px;font-size: 14px;">
                    产品详情>
                </div>
            </div>
            <div style="width: 590px;height: 270px;background-size: 100% 100%;text-align: center;cursor: pointer;" @click="znkfu"
                :style="{ backgroundImage: 'url(' + require('@/assets/AI/AI_01.png') + ')' }">
                <div style="margin-top: 30px;"><img style="margin: 0px auto;width:60px;"
                        src="../../assets/AI/AI_05.png"></div>
                <div style="margin-top: 20px;font-size: 20px;font-weight: bold;">AI智能客服</div>
                <div style="margin-top: 15px;font-size: 15px;">基于生成式AI的全渠道对话引擎，实现服务与业务场景智能化</div>
                <div
                    style="margin: 0px auto; margin-top: 20px;width: 110px;height: 36px;line-height: 36px;color: #1e66d1;border: 1px solid #1e66d1;border-radius: 20px;font-size: 14px;">
                    产品详情>
                </div>
            </div>
        </div> -->
        <div style="margin-top: 90px;">
            <div style="text-align: center;font-size: 28px;">产品特性</div>
            <div style="display: flex;flex-wrap: wrap;width: 1200px;margin: 0px auto;justify-content: space-between;">
                <div style="margin-top: 65px;display: flex;width: 28%;">
                    <div><img src="../../assets/AI/AI_07.png" style="width: 55px;"></div>
                    <div style="margin-left: 15px;flex: 1;">
                        <div style="font-size: 18px;color: #1e66d1;">智能语义理解</div>
                        <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">支持自然语言查询，精准匹配知识内容，准确率＞95%无缝对接企业
                        </div>
                    </div>
                </div>
                <div style="margin-top: 65px;display: flex;width: 28%;">
                    <div><img src="../../assets/AI/AI_08.png" style="width: 55px;"></div>
                    <div style="margin-left: 15px;flex: 1;">
                        <div style="font-size: 18px;color: #1e66d1;">多源异构整合</div>
                        <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">
                            无缝对接企业CRM/ERP/文档系统，支持文本/表格/音视频等多模态数据统一管理</div>
                    </div>
                </div>
                <div style="margin-top: 65px;display: flex;width: 28%;">
                    <div><img src="../../assets/AI/AI_09.png" style="width: 55px;"></div>
                    <div style="margin-left: 15px;flex: 1;">
                        <div style="font-size: 18px;color: #1e66d1;">动态自学习</div>
                        <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">自动识别知识盲区并触发更新，通过用户反馈闭环实现模型月度迭代优化
                        </div>
                    </div>
                </div>
                <div style="margin-top: 65px;display: flex;width: 28%;">
                    <div><img src="../../assets/AI/AI_10.png" style="width: 55px;"></div>
                    <div style="margin-left: 15px;flex: 1;">
                        <div style="font-size: 18px;color: #1e66d1;">生成式对话引擎</div>
                        <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">基于业务上下文生成操作指南（如“生成客户投诉处理
                            SOP”），支持多轮追问与逻辑推理</div>
                    </div>
                </div>
                <div style="margin-top: 65px;display: flex;width: 28%;">
                    <div><img src="../../assets/AI/AI_11.png" style="width: 55px;"></div>
                    <div style="margin-left: 15px;flex: 1;">
                        <div style="font-size: 18px;color: #1e66d1;">分布式会话管理</div>
                        <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">
                            {{ '支持百万级并发对话，会话状态丢失率<0.01%，复杂业务场景下响应延迟<800ms' }} </div>
                        </div>
                    </div>
                    <div style="margin-top: 65px;display: flex;width: 28%;">
                        <div><img src="../../assets/AI/AI_12.png" style="width: 55px;"></div>
                        <div style="margin-left: 15px;flex: 1;">
                            <div style="font-size: 18px;color: #1e66d1;">风险可控</div>
                            <div style="font-size: 14px;margin-top: 5px;line-height: 25px;">
                                支持私有化部署+字段级权限控制，满足医疗/金融等行业合规要求
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 90px;background: #f5f5f5;padding-top: 68px;padding-bottom: 100px;">
                <div style="font-size: 28px;text-align: center;">支持私有化部署</div>
                <div style="margin:0px auto;margin-top: 40px;font-size: 14px;line-height: 25px;width: 980px;">
                    支持企业在自有算力环境中部署DeepSeek模型，结合垂直场景数据精调优化，集成RAG增强检索、多源搜索与自动化工作流，构建安全可控的定制化知识服务体系，满足数据隐私与业务适配需求。</div>
                <div style="margin-top: 30px;">
                    <img src="../../assets/AI/AI_06.jpg" style="margin:0px auto;">
                </div>
                <div style="margin-top: 85px;font-size: 28px;text-align: center;">私有化部署优势</div>
                <div>
                    <img src="../../assets/AI/AI_13.jpg" style="margin:0px auto;">
                </div>
                <div style="background: #fff;width: 1200px;display: flex;margin: 0px auto;">
                    <div style="height: 300px;width: 340px;padding: 0px 20px;">
                        <div style="margin-top: 35px;"><img src="../../assets/AI/AI_15.png"
                                style="margin:0px auto;height: 50px;"></div>
                        <div
                            style="font-size: 16px;font-weight: bold;color: #1e66d1;margin-top: 15px;text-align: center;">
                            数据模型封闭管理</div>
                        <div style="font-size: 14px;margin-top: 30px;">
                            所有数据存储与模型运行均在内部服务器完成，医疗、金融等高敏信息全程“不出门”；物理隔离环境杜绝云端传输风险，满足企业数据主权硬性要求</div>
                    </div>
                    <div style="height: 300px;width: 340px;padding: 0px 20px;">
                        <div style="margin-top: 35px;"><img src="../../assets/AI/AI_16.png"
                                style="margin:0px auto;height: 50px;"></div>
                        <div
                            style="font-size: 16px;font-weight: bold;color: #1e66d1;margin-top: 15px;text-align: center;">
                            核心资产不泄露</div>
                        <div style="font-size: 14px;margin-top: 30px;">
                            模型参数与训练细节企业自主管控，结合硬件级加密防护；保护制造业工艺算法、零售用户画像等商业机密，杜绝技术泄密风险</div>
                    </div>
                    <div style="height: 300px;width: 340px;padding: 0px 20px;">
                        <div style="margin-top: 35px;"><img src="../../assets/AI/AI_17.png"
                                style="margin:0px auto;height: 50px;"></div>
                        <div
                            style="font-size: 16px;font-weight: bold;color: #1e66d1;margin-top: 15px;text-align: center;">
                            量身定制业务效果</div>
                        <div style="font-size: 14px;margin-top: 30px;">
                            基于企业特有数据（如10万+维修工单）定向优化模型，精准识别行业术语（如“冷轧机跑偏”），关键任务准确率提升30%-50%，真正解决业务痛点</div>
                    </div>
                    <div style="height: 300px;width: 340px;padding: 0px 20px;">
                        <div style="margin-top: 35px;"><img src="../../assets/AI/AI_18.png"
                                style="margin:0px auto;height: 50px;"></div>
                        <div
                            style="font-size: 16px;font-weight: bold;color: #1e66d1;margin-top: 15px;text-align: center;">
                            自主掌控灵活升级</div>
                        <div style="font-size: 14px;margin-top: 30px;">
                            支持按需热更新模型功能，政策变化3天内完成迭代；可自定义知识库同步策略，分部门部署差异化版本，摆脱厂商依赖
                        </div>
                    </div>
                    <div style="height: 300px;width: 340px;padding: 0px 20px;">
                        <div style="margin-top: 35px;"><img src="../../assets/AI/AI_19.png"
                                style="margin:0px auto;height: 50px;"></div>
                        <div
                            style="font-size: 16px;font-weight: bold;color: #1e66d1;margin-top: 15px;text-align: center;">
                            本地运行快稳兼备</div>
                        <div style="font-size: 14px;margin-top: 30px;">
                            本地GPU集群实现千并发毫秒级响应，复杂任务处理效率提升3-5倍；断网仍可运行，全年故障率＜0.001%，保障业务连续性</div>
                    </div>
                </div>
            </div>
            <!-- <div style="padding-bottom: 80px;" id="section1">
                <div style="height: 85px;"></div>
                <div style="font-size: 28px;text-align: center;">DeepSeek+知识库</div>
                <div style="margin:0px auto;margin-top: 40px;font-size: 14px;line-height: 25px;width: 980px;">
                    DeepSeek+DeepSeek+知识库 是企业级智能数据引擎。它能打破信息孤岛，将分散的文档、音视频及客户反馈等多源异构数据，通过多模态整合与深度语义分析，提炼出可直接驱动业务增长的关键价值——例如生成精准维修方案、发出风险预警、挖掘潜在商机。让沉睡的数据资产不再只是成本负担，而成为推动企业增长的强劲动力源。
                </div>
                <div style="margin-top: 80px;">
                    <img src="../../assets/AI/AI_14.jpg" style="margin:0px auto;">
                </div>
                <div style="margin-top: 80px;font-size: 28px;text-align: center;" id="section3">应用场景</div>
                <div style="background: #fff;width: 1200px;display: flex;margin: 0px auto;margin-top: 50px;position: relative;"
                    class="ai-yycj">
                    <div class="div" :class="{ 'isdiv': index == 0 }" @mouseenter="index = 0">企业知识资产统一管理</div>
                    <div class="div" :class="{ 'isdiv': index == 1 }" @mouseenter="index = 1">合规审计自动化</div>
                    <div class="div" :class="{ 'isdiv': index == 2 }" @mouseenter="index = 2">研发知识协同</div>
                    <div class="div" :class="{ 'isdiv': index == 3 }" @mouseenter="index = 3">供应链风险预警</div>
                    <div style="position: absolute;background: #fff;width: 64px;height: 2px;bottom: 0px;"
                        :style="{ 'left': ((index * 300) + 118) + 'px' }">
                    </div>
                </div>
                <div style="width: 1200px;margin: 0px auto;background: #1e66d1;background-size: 101% 100%;"
                    :style="{ backgroundImage: 'url(' + require('@/assets/AI/AI_20.jpg') + ')' }">
                    <div style="display: flex;padding-top:55px;height: 220px;" v-if="index == 0">
                        <div style="width: 50%;padding: 0px 50px;display: flex;">
                            <div><img src="../../assets/AI/AI_23.png" style="height: 52px;"></div>
                            <div style="margin-left: 15px;flex: 1;">
                                <div style="font-size: 16px;color: #fff;">场景诉求</div>
                                <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                    分散在多个系统（CRM/ERP/Confluence）中的产品文档、技术方案、会议纪要等非结构化数据难以整合。</div>
                            </div>
                        </div>
                        <div style="width: 50%;padding: 0px 50px;display: flex;">
                            <div><img src="../../assets/AI/AI_24.png" style="height: 52px;"></div>
                            <div style="margin-left: 15px;flex: 1;">
                                <div style="font-size: 16px;color: #fff;">解决方案</div>
                                <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                    <div>实时同步多源数据，构建“产品参数-客户案例-故障解决方案”动态知识图谱。
                                        支持自然语言模糊查询（如“类似A客户的方案”），结果关联度＞90%。
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex;padding-top:55px;height: 220px;" v-if="index == 1">
                        <div style="width: 50%;padding: 0px 50px;display: flex;">
                            <div><img src="../../assets/AI/AI_23.png" style="height: 52px;"></div>
                            <div style="margin-left: 15px;flex: 1;">
                                <div style="font-size: 16px;color: #fff;">场景诉求</div>
                                <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                    人工审核海量合同、邮件存在漏检风险（如金融条款违规、医疗数据泄露）。</div>
                            </div>
                        </div>
                        <div style="width: 50%;padding: 0px 50px;display: flex;">
                            <div><img src="../../assets/AI/AI_24.png" style="height: 52px;"></div>
                            <div style="margin-left: 15px;flex: 1;">
                                <div style="font-size: 16px;color: #fff;">解决方案</div>
                                <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                    <div>嵌入行业合规规则库（金融/医疗/法律），实时扫描文档并标记风险点。
                                        高风险操作自动阻断（如含“保证收益”的理财话术），同步生成合规修正建议。
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex;padding-top:55px;height: 220px;" v-if="index == 2">
                        <div style="width: 50%;padding: 0px 50px;display: flex;">
                            <div><img src="../../assets/AI/AI_23.png" style="height: 52px;"></div>
                            <div style="margin-left: 15px;flex: 1;">
                                <div style="font-size: 16px;color: #fff;">场景诉求</div>
                                <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                    研发团队分散在多地，技术文档版本混乱，协作效率低。</div>
                            </div>
                        </div>
                        <div style="width: 50%;padding: 0px 50px;display: flex;">
                            <div><img src="../../assets/AI/AI_24.png" style="height: 52px;"></div>
                            <div style="margin-left: 15px;flex: 1;">
                                <div style="font-size: 16px;color: #fff;">解决方案</div>
                                <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                    <div>自动追踪代码/文档变更，冲突检测后推送关联责任人。
                                        基于项目需求智能推荐历史方案（如“推荐5个相似模块的测试用例”）。
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex;padding-top:55px;height: 220px;" v-if="index == 3">
                        <div style="width: 50%;padding: 0px 50px;display: flex;">
                            <div><img src="../../assets/AI/AI_23.png" style="height: 52px;"></div>
                            <div style="margin-left: 15px;flex: 1;">
                                <div style="font-size: 16px;color: #fff;">场景诉求</div>
                                <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                    供应商交货延迟、原材料价格波动等风险难以及时发现。</div>
                            </div>
                        </div>
                        <div style="width: 50%;padding: 0px 50px;display: flex;">
                            <div><img src="../../assets/AI/AI_24.png" style="height: 52px;"></div>
                            <div style="margin-left: 15px;flex: 1;">
                                <div style="font-size: 16px;color: #fff;">解决方案</div>
                                <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                    <div>整合采购数据、市场情报、物流记录，生成供应链风险热力图。指数并触发预警。
                                        自动触发应急策略（如“推荐替代供应商清单”或“安全库存预警”）。
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="background: #f5f5f5;padding-top: 68px;padding-bottom: 60px;">
                <div style="font-size: 28px;text-align: center;">功能展示</div>
                <div style="margin:0px auto;margin-top: 40px;font-size: 14px;line-height: 25px;text-align: center;">
                    本地文档知识库系统，与AI大模型结合，搜索+AI问答构建新的知识检索方式。</div>
                <div style="margin-top: 30px;display: flex;justify-content: center;">
                    <div class="ai-gnzs" style="width: 160px;">
                        <div :class="{'isdiv':indexc==0}" @mouseenter="indexc=0">知识库首页</div>
                        <div :class="{'isdiv':indexc==1}" @mouseenter="indexc=1">知识管理</div>
                        <div :class="{'isdiv':indexc==2}" @mouseenter="indexc=2">分层管理</div>
                        <div :class="{'isdiv':indexc==3}" @mouseenter="indexc=3">知识库问答</div>
                        <div :class="{'isdiv':indexc==4}" @mouseenter="indexc=4">系统集成</div>
                    </div>
                    <div style="margin-left: 0px;width: 1040px;">
                        <img v-if="indexc==0" src="../../assets/home/gnzs1.png" style="margin:0px auto;background: #fff;padding:5px;">
                        <img v-if="indexc==1" src="../../assets/home/gnzs2.png" style="margin:0px auto;background: #fff;padding:5px;">
                        <img v-if="indexc==2" src="../../assets/home/gnzs3.png" style="margin:0px auto;background: #fff;padding:5px;">
                        <img v-if="indexc==3" src="../../assets/home/gnzs4.png" style="margin:0px auto;background: #fff;padding:5px;">
                        <img v-if="indexc==4" src="../../assets/home/gnzs5.png" style="margin:0px auto;background: #fff;padding:5px;">
                    </div>
                </div>
            </div>
            <div style="padding-bottom: 80px;position: relative;" id="section2">
                <div>
                    <img src="../../assets/AI/AI_22.jpg" style="margin:0px auto;">
                    <div>
                        <div style="margin-top: 80px;font-size: 28px;text-align: center;">应用场景</div>
                        <div style="background: #fff;width: 1200px;display: flex;margin: 0px auto;margin-top: 50px;position: relative;"
                            class="ai-yycj">
                            <div class="div" :class="{ 'isdiv': indexb == 0 }" @mouseenter="indexb = 0">多模态复杂问题处理</div>
                            <div class="div" :class="{ 'isdiv': indexb == 1 }" @mouseenter="indexb = 1">情感化服务调解</div>
                            <div class="div" :class="{ 'isdiv': indexb == 2 }" @mouseenter="indexb = 2">长周期客户关系维护</div>
                            <div class="div" :class="{ 'isdiv': indexb == 3 }" @mouseenter="indexb = 3">销售机会智能挖掘</div>
                            <div style="position: absolute;background: #fff;width: 64px;height: 2px;bottom: 0px;"
                                :style="{ 'left': ((indexb * 300) + 118) + 'px' }">
                            </div>
                        </div>
                        <div style="width: 1200px;margin: 0px auto;background: #1e66d1;background-size: 101% 100%;"
                            :style="{ backgroundImage: 'url(' + require('@/assets/AI/AI_20.jpg') + ')' }">
                            <div style="display: flex;padding-top:55px;height: 220px;" v-if="indexb == 0">
                                <div style="width: 50%;padding: 0px 50px;display: flex;">
                                    <div><img src="../../assets/AI/AI_23.png" style="height: 52px;"></div>
                                    <div style="margin-left: 15px;flex: 1;">
                                        <div style="font-size: 16px;color: #fff;">场景诉求</div>
                                        <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                            客户咨询需同时上传设备故障视频、文字描述和图片，传统客服无法关联分析多类型信息，问题解决周期长达48小时以上。</div>
                                    </div>
                                </div>
                                <div style="width: 50%;padding: 0px 50px;display: flex;">
                                    <div><img src="../../assets/AI/AI_24.png" style="height: 52px;"></div>
                                    <div style="margin-left: 15px;flex: 1;">
                                        <div style="font-size: 16px;color: #fff;">解决方案</div>
                                        <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                            <div>智能解析：同步识别视频中的设备异常画面、文字描述的故障代码、图片中的部件状态。</div>
                                            <div>即时响应：自动生成图文版排查指南（含备件更换示意图），并附带维修预约链接。</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex;padding-top:55px;height: 220px;" v-if="indexb == 1">
                                <div style="width: 50%;padding: 0px 50px;display: flex;">
                                    <div><img src="../../assets/AI/AI_23.png" style="height: 52px;"></div>
                                    <div style="margin-left: 15px;flex: 1;">
                                        <div style="font-size: 16px;color: #fff;">场景诉求</div>
                                        <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                            客户因投诉处理延迟产生强烈不满，需快速安抚避免升级。</div>
                                    </div>
                                </div>
                                <div style="width: 50%;padding: 0px 50px;display: flex;">
                                    <div><img src="../../assets/AI/AI_24.png" style="height: 52px;"></div>
                                    <div style="margin-left: 15px;flex: 1;">
                                        <div style="font-size: 16px;color: #fff;">解决方案</div>
                                        <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                            <div>情绪雷达：实时检测语音语调/文字关键词（如“投诉”）。</div>
                                            <div>分级应对：普通焦虑可自动发送服务进度通知（“您的订单将于12小时内发货”）；严重冲突则秒转专家坐席并推送客户画像（历史订单+沟通记录）。</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex;padding-top:55px;height: 220px;" v-if="indexb == 2">
                                <div style="width: 50%;padding: 0px 50px;display: flex;">
                                    <div><img src="../../assets/AI/AI_23.png" style="height: 52px;"></div>
                                    <div style="margin-left: 15px;flex: 1;">
                                        <div style="font-size: 16px;color: #fff;">场景诉求</div>
                                        <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                            客户历史交互记录分散，重复咨询时需重新描述问题。</div>
                                    </div>
                                </div>
                                <div style="width: 50%;padding: 0px 50px;display: flex;">
                                    <div><img src="../../assets/AI/AI_24.png" style="height: 52px;"></div>
                                    <div style="margin-left: 15px;flex: 1;">
                                        <div style="font-size: 16px;color: #fff;">解决方案</div>
                                        <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                            <div>记忆强化：自动关联180天内全渠道交互记录（电话/在线/邮件），主动提示：“您上周咨询的XX问题已有新进展，点击查看详情”。</div>
                                            <div>预见服务：基于服务周期触发提醒（如“您购买的设备还剩15天保修期”）。</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex;padding-top:55px;height: 220px;" v-if="indexb == 3">
                                <div style="width: 50%;padding: 0px 50px;display: flex;">
                                    <div><img src="../../assets/AI/AI_23.png" style="height: 52px;"></div>
                                    <div style="margin-left: 15px;flex: 1;">
                                        <div style="font-size: 16px;color: #fff;">场景诉求</div>
                                        <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                            客户咨询中隐含比价、扩容等潜在需求，传统客服难以识别。</div>
                                    </div>
                                </div>
                                <div style="width: 50%;padding: 0px 50px;display: flex;">
                                    <div><img src="../../assets/AI/AI_24.png" style="height: 52px;"></div>
                                    <div style="margin-left: 15px;flex: 1;">
                                        <div style="font-size: 16px;color: #fff;">解决方案</div>
                                        <div style="font-size: 14px;color: #aac4eb;margin-top: 5px;line-height: 25px;">
                                            <div>深度洞察：识别6类购买信号（比价/扩容/功能缺陷对比），自动标记高意向对话并推送销售部门。</div>
                                            <div>精准打击：根据对话内容生成《客户定制方案》（含竞品对比数据）。</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="position: absolute;top: 60px;width: 100%;">
                    <div style="font-size: 28px;text-align: center;">AI智能客服</div>
                    <div style="margin:0px auto;margin-top: 40px;font-size: 14px;line-height: 25px;width: 980px;">
                        基于生成式AI的全渠道对话引擎，理解复杂语义并生成个性化解决方案，支持情绪识别与业务系统联动（如自动生成工单），应用于客户咨询诊断、销售机会挖掘等场景，问题解决率提升至89%。
                    </div>
                </div>
            </div>
            <div id="section4">
                <img src="../../assets/AI/AI_25.jpg" style="width: 100%;">
            </div>
            <div style="margin-top: 85px;margin-bottom: 100px;">
                <div style="font-size: 28px;text-align: center;">功能展示</div>
                <div
                    style="height: 50px;width: 1100px;margin: 0px auto;line-height: 50px;background: #ebf3fb;margin-top: 65px;font-size: 18px;color: #1e66d1;">
                    <label style="font-weight: bold;margin-left: 30px;">微信客服后端管控</label>
                    <label style="margin-left: 30px;">（自助导航、接待看板、咨询列表、会话存档）</label>
                </div>
                <div><img src="../../assets/AI/AI_28.jpg" style="margin: 0px auto;margin-top: 20px;"></div>
                <div
                    style="height: 50px;width: 1100px;margin: 0px auto;line-height: 50px;background: #ebf3fb;margin-top: 65px;font-size: 18px;color: #1e66d1;">
                    <label style="font-weight: bold;margin-left: 30px;">前端使用</label>
                    <label style="margin-left: 30px;">（AI客服、自动识别推送关键信息、多轮次回答、语音识别交互）</label>
                </div>
                <div><img src="../../assets/AI/AI_31.png" style="margin: 0px auto;margin-top: 20px;"></div>
            </div> -->
        </div>
</template>
<script>
export default {
    data() {
        return {
            index: 0,
            indexb: 0,
            indexc: 0
        }
    },
    mounted() {
    },
    methods: {
        tof(title) {
            this.$router.push({ name: 'AIMenu', query: { title: title } })
        },
        zhichiku() {
            var targetPosition = document.getElementById("section1").getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: targetPosition - 60,
                behavior: 'smooth' // 平滑滚动效果
            });
            // var targetPosition = document.getElementById("section3").getBoundingClientRect().top + window.pageYOffset;
            // window.scrollTo({
            //     top: targetPosition,
            //     behavior: 'smooth' // 平滑滚动效果
            // });
        },
        znkfu() {
            var targetPosition = document.getElementById("section2").getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: targetPosition - 60,
                behavior: 'smooth' // 平滑滚动效果
            });
            // var targetPosition = document.getElementById("section4").getBoundingClientRect().top + window.pageYOffset;
            // window.scrollTo({
            //     top: targetPosition-120,
            //     behavior: 'smooth' // 平滑滚动效果
            // });
        }
    }
}
</script>
<style scoped>
.slogan-text-font {
    font-size: 36px;
    display: flex;
    align-items: center;
}

.slogan-detail-card-title {
    font-size: 20px;
    display: relative;
}

.slogan-card {
    color: var(--color-content1);
    display: flex;
    height: 250px;
    width: 200px;
    flex-direction: column;
    align-items: center;
    border-radius: 1rem;
    background-color: rgb(255 255 255 / 0.8);
    padding-top: 2rem;
    padding-bottom: 2rem;
    font-size: 0.875rem;
    line-height: 1.75rem;
}

::v-deep #content p {
    text-indent: 2em;
    line-height: 35px;
    font-size: 16px;
}

::v-deep #content p:nth-child(2) {
    margin-top: 35px;
}

::v-deep #content p:nth-child(3) {
    margin-top: 35px;
}

.ai-yycj .div {
    width: 300px;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    text-align: center;
    border-radius: 15px 15px 0px 0px;
    cursor: pointer;
}

.ai-yycj .isdiv {
    font-weight: bold;
    background: #1e66d1;
    color: #fff;
}

.ai-gnzs div {
    width: 160px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    color: #999999;
    background: #ebebeb;
    margin-bottom: 10px;
    border-radius: 10px;
    cursor: pointer;
}

.ai-gnzs .isdiv {
    background: #fff;
    color: #333;
}

/* img{
  width:100%;
  height:100%;
} */
</style>
